export default __webpack_public_path__ + "images/7Y.1d27383.png";